
export const ru = {
  auth: {
    login: "Войти",
    startFreeTrial: "Начать бесплатный период",
    register: "Регистрация",
    email: "Электронная почта",
    password: "Пароль",
    forgotPassword: "Забыли пароль?",
    alreadyHaveAccount: "Уже есть аккаунт?",
    dontHaveAccount: "Нет аккаунта?",
    errorDescription: "Произошла ошибка",
    errorTitle: "Ошибка",
    successTitle: "Успех",
    successDescription: "Операция выполнена успешно",
    continueWithGoogle: "Продолжить с Google",
    createAccount: "Создать аккаунт",
    trialDescription: "14 дней бесплатно",
    emailPlaceholder: "ваш@email.com",
    creating: "Создание...",
    create: "Создать",
    errorMessage: "Произошла ошибка"
  },
  navigation: {
    pricing: "Цены",
    about: "О нас",
    contact: "Контакты",
    themes: "Темы",
    resources: "Ресурсы",
    home: "Главная",
    dashboard: "Панель управления",
    products: "Товары",
    orders: "Заказы",
    customers: "Клиенты",
    settings: "Настройки"
  },
  footer: {
    acceptedPayments: "Принимаемые платежи",
    allRightsReserved: "Все права защищены",
    quickLinks: "Быстрые ссылки",
    legalNotice: "Правовая информация",
    accessibility: "Доступность",
    termsOfUse: "Условия использования",
    support: "Поддержка",
    followUs: "Подписывайтесь на нас",
    socialMedia: "Мы в социальных сетях",
    newsletter: "Рассылка",
    subscribeNewsletter: "Подпишитесь на нашу рассылку",
    emailPlaceholder: "Ваш email",
    subscribe: "Подписаться",
    changeLanguage: "Изменить язык"
  },
  pricing: {
    title: "Планы и цены",
    subtitle: "Выберите подходящий план",
    startTrial: "Начать бесплатный период",
    mostPopular: "Самый популярный",
    freeTrial: "14 дней бесплатно",
    perMonth: "/месяц",
    basic: {
      name: "Базовый",
      price: "11",
      description: "Для начала",
      features: [
        "1 магазин",
        "100 товаров",
        "Поддержка по email"
      ]
    },
    pro: {
      name: "Про",
      price: "25",
      description: "Для профессионалов",
      features: [
        "3 магазина",
        "1000 товаров",
        "Приоритетная поддержка",
        "Расширенная аналитика"
      ]
    },
    enterprise: {
      name: "Корпоративный",
      price: "97",
      description: "Для крупных компаний",
      features: [
        "Неограниченное количество магазинов",
        "Неограниченное количество товаров",
        "Выделенная поддержка",
        "Собственное API"
      ]
    }
  },
  profile: {
    title: "Мой профиль",
    fullName: "Полное имя",
    phoneNumber: "Номер телефона",
    update: "Обновить",
    updating: "Обновление...",
    success: "Профиль успешно обновлен",
    error: "Ошибка при обновлении профиля"
  },
  common: {
    loading: "Загрузка...",
    error: "Ошибка",
    success: "Успех",
    save: "Сохранить",
    cancel: "Отмена",
    delete: "Удалить",
    edit: "Редактировать",
    create: "Создать",
    search: "Поиск",
    filter: "Фильтр",
    sort: "Сортировка",
    actions: "Действия",
    confirm: "Подтвердить",
    back: "Назад",
    next: "Далее",
    previous: "Назад",
    close: "Закрыть"
  }
};
